// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.no-items-found-list-message[data-v-5f068212] {\n    padding: 2em 2em !important;\n    text-align: center !important;\n}\n", ""]);
// Exports
module.exports = exports;
